'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// https://www.dropbox.com/branding
// Blue glyph from https://www.dropbox.com/sh/eokvcxamvx2u7sv/AABo7i32c5cKCfFoiJA7NaXea/01_Logos/05_Glyphs/Glyph/Blue/SVG?dl=0&preview=dropbox_glyph_blue.svg
var Dropbox = (_temp = _class = function (_SvgIcon) {
  _inherits(Dropbox, _SvgIcon);

  function Dropbox() {
    _classCallCheck(this, Dropbox);

    return _possibleConstructorReturn(this, (Dropbox.__proto__ || Object.getPrototypeOf(Dropbox)).apply(this, arguments));
  }

  _createClass(Dropbox, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('polygon', {
            fill: '#007EE5',
            points: '63.387,36.169 32.5,56.336 53.857,73.438 85,54.208'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#007EE5',
            points: '32.5,90.542 63.387,110.709 85,92.669 53.857,73.438'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#007EE5',
            points: '85,92.669 106.613,110.709 137.5,90.542 116.143,73.438'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#007EE5',
            points: '137.5,56.336 106.613,36.169 85,54.208 116.143,73.438'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#007EE5',
            points: '85.064,96.55 63.387,114.537 54.112,108.481 54.112,115.27 85.064,133.831 116.015,115.27 116.015,108.481 106.74,114.537 \t'
          })
        );
      }

      return render;
    }()
  }]);

  return Dropbox;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 170 170'
}, _temp);
exports['default'] = Dropbox;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Dropbox.js
// module id = 1364
// module chunks = 32